import {
    WidgetStreamState,
    StreamTimeSeriesState,
} from 'widgets/store/stream/WidgetStreamState';
import { IntraDayProfileTimeElement } from 'communication/types/intraDayProfile/IntraDayProfileElement';

export type IntraDayProfileStreamState =
    WidgetStreamState<IntraDayProfileDataState>;

export interface IntraDayProfileDataState
    extends StreamTimeSeriesState<IntraDayProfileTimeElement> {
    excRanges?: number[];
}

export const initialIntraDayProfileDataState: IntraDayProfileDataState = {
    timeSeries: [],
};

export const initialIntraDayProfileStreamState: IntraDayProfileStreamState = {
    data: initialIntraDayProfileDataState,
    messages: [],
};
